import { Component } from '@angular/core';

@Component({
  selector: 'app-page-error',
  templateUrl: './page-error.component.html',
  standalone: false,
})
export class PageErrorComponent {
}
